import React from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../admin/Footer";
import Header from "../admin/Header";
import { FaHome } from "react-icons/fa";

const LastPage = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <>
      <Header />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "40px 20px",
          minHeight: "calc(100vh - 160px)", // subtracting approx header/footer height
          backgroundColor: "#f9f9f9",
        }}
      >
        <div
          style={{
            backgroundColor: "#fff",
            padding: "30px",
            borderRadius: "10px",
            maxWidth: "600px",
            width: "100%",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            textAlign: "center",
          }}
        >
          <h1
            style={{
              fontSize: "24px",
              marginBottom: "20px",
              color: "#333",
              lineHeight: "1.4",
            }}
          >
            धन्यवाद! आपला फॉर्म यशस्वीरित्या भरला गेला आहे!
          </h1>

          <button
            onClick={handleGoHome}
            style={{
              marginTop: "20px",
              padding: "10px 20px",
              backgroundColor: "#007bff",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              fontSize: "16px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              width: "fit-content",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <FaHome /> होम पेज
          </button>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default LastPage;
